import { React, useState,useRef, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import cloneDeep from 'lodash/cloneDeep';
import Avatar from '@mui/material/Avatar';
import { GoogleMap, LoadScript, Data, DrawingManager, Circle, Polygon, LatLngBounds } from '@react-google-maps/api';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Popover from '@mui/material/Popover';
import ConfirmDialog from '../Modals/ConfirmDialog';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import DrawableMap from '../MyAccount/DrawableMap';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteIcon from '@mui/icons-material/Delete';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import {
    Card,
    CardContent,
    Accordion,
    AccordionDetails,
    AccordionSummary,
}
    from '@mui/material/'

function RecyclerItem(props) {
    var utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration');
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime');
    dayjs.extend(relativeTime);

    const [recycler, setRecycler] = useState(props.recycler);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const softBanNotes = useRef(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const metersPerMile = 1609.34;

    function buildShapes() {
        let currentAreas = [];
        let bounds = {
            north: 0,
            east: 0,
            south: 0,
            west: 0
        }
        // let bounds = LatLngBounds
        for (let i = 0; i < recycler.ServiceAreas.length; i++) {
            if (recycler.ServiceAreas[i].AreaType == 1 &&
                recycler.ServiceAreas[i].Geography != null &&
                recycler.ServiceAreas[i].Geography.length > 0) {
                // zipcode shape
                for (let shapeCount = 0; shapeCount < recycler.ServiceAreas[i].Geography.length; shapeCount++) {
                    currentAreas.push(<Polygon key={'Shape_' + recycler.ServiceAreas[i].ServiceAreaId + '_' + shapeCount}
                        paths={recycler.ServiceAreas[i].Geography[shapeCount].Points}
                        onClick={() => { /*handleShapeClick*/ }}
                        options={{
                            strokeColor: '#0000FF',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: '#0000FF',
                            fillOpacity: 0.35,
                            clickable: true,
                            draggable: false,
                            editable: false,
                            visible: true,
                            geodesic: false,
                            zIndex: 1,
                            ServiceArea: recycler.ServiceAreas[i]
                        }}
                    />);
                }

                //item = new google.maps.Polygon({
                //    paths: shapeCoords.Points,
                //    strokeColor: "#0000FF",
                //    strokeOpacity: 0.6,
                //    strokeWeight: 1,
                //    fillColor: "#0000FF",
                //    fillOpacity: 0.35,
                //    returnerId: serviceArea.ReturnerId, // no longer used
                //    ServiceAreaId: serviceArea.ServiceAreaId,// no longer used
                //    returnerIds: [serviceArea.ReturnerId],
                //    serviceAreaIds: [serviceArea.ServiceAreaId],
                //    zipcode: serviceArea.Zipcode
                //});
            }
            else if (recycler.ServiceAreas[i].AreaType == 2) {
                // circles
                currentAreas.push(<Circle key={'Shape_' + recycler.ServiceAreas[i].ServiceAreaId}
                    center={{
                        lat: recycler.ServiceAreas[i].Latitude, lng: recycler.ServiceAreas[i].Longitude
                    }}
                    onClick={() => { /*handleShapeClick*/ }}
                    // required
                    options={{
                        strokeColor: '#0000FF',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#0000FF',
                        fillOpacity: 0.35,
                        clickable: true,

                        draggable: false,
                        editable: false,
                        visible: true,
                        radius: recycler.ServiceAreas[i].RadiusMiles * metersPerMile,
                        zIndex: 1,
                        ServiceArea: recycler.ServiceAreas[i]
                    }}
                />
                )
            }
        }
        return currentAreas;
    }

   
    let lastLogin;
    if (recycler.LastLoginDateTimeUTC.Data == null) {
        lastLogin = 'Never';
    }
    else {
        let currentUTC = dayjs.utc();
        let minutesSince = Math.abs(dayjs(recycler.LastLoginDateTimeUTC.Data).diff(dayjs.utc(), 'minute'))
        lastLogin = dayjs.duration({ minutes: minutesSince }).humanize()
    }

    let zipcodeCounts = 0;
    let shapeCounts = 0;

    for (let i = 0; i < recycler.ServiceAreas.length; i++) {
        if (recycler.ServiceAreas[i].AreaType == 1) {
            zipcodeCounts++;
        }
        else {
            shapeCounts++;
        }
    }

    function handleAbilityUpdate(enabled, ability) {
        let postData = {
            returnerId: recycler.ID,
            ability: ability,
            value: enabled
        }

       // Admin_ReturnerAbilityUpdate(int returnerId, string ability, bool value)
        TokenService.adminServicePost(postData, 'Admin_ReturnerAbilityUpdate')

            .then((response) => {

                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    //let jsonData = JSON.parse(response.JsonData);
                    // setRecyclers(jsonData);
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });

            });

        if (ability == 'RecycleFirst') {
            let temp = cloneDeep(recycler);
            temp.Abilities.RecycleFirst = enabled;
            setRecycler(temp);
            if (props.onUpdate !== undefined) {
                props.onUpdate(temp);
            }
        }
    }

    function handleHardBanUpdate(enabled) {
        let postData = {
            returnerId: recycler.ID,
            isActive: !enabled
        }

        // Admin_ReturnerAbilityUpdate(int returnerId, string ability, bool value)
        TokenService.adminServicePost(postData, 'Admin_ReturnerUpdateIsActive')

            .then((response) => {

                if (response.Result == "SUCCESS") {
                    //let jsonData = JSON.parse(response.JsonData);
                    // setRecyclers(jsonData);
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });

            });

        let temp = cloneDeep(recycler);
        temp.IsActive = !enabled;
        setRecycler(temp);
        if (props.onUpdate !== undefined) {
            props.onUpdate(temp);
        }
    }

    function handleSoftBanChanged(enabled) {

        if (!enabled) {
            let postData = {
                bannedId: recycler.Ban.Returner_BannedId,
            }

            TokenService.adminServicePost(postData, 'Admin_ReturnerRemoveSoftBan')

                .then((response) => {

                    
                    if (response.Result == "SUCCESS") {
                        
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });

                });

            
            let temp = cloneDeep(recycler);
            temp.Ban = null;
            setRecycler(temp);
            if (props.onUpdate !== undefined) {
                props.onUpdate(temp);
            }
            
        }
        else {
           
            // show a popup for Notes
            setConfirmDialog({
                show: true,
                close: closeSoftBanDialog,
                title: 'Add a Soft Ban?',
                cancelText: 'Cancel',
                acceptText: 'Proceed',
                content: <div>
                    <div>This will not allow anyone with this phone number to claim a pickup.</div>
                    <div style={ {marginTop:'10px' }}>
                        <TextField label='Notes' inputRef={softBanNotes} /></div>
                </div>,
                data: ''
            });
        }
       

        // Admin_ReturnerAbilityUpdate(int returnerId, string ability, bool value)
        
    }
 

    function closeSoftBanDialog(didAccept) {
        if (didAccept) {
            
            let postData = {
                returnerId: recycler.ID,
                notes: softBanNotes.current.value
            }

            TokenService.adminServicePost(postData, 'Admin_ReturnerAddSoftBan')

                .then((response) => {

                  
                    if (response.Result == "SUCCESS") {
                        let data = JSON.parse(response.JsonData);
                        recycler.Ban = data;
                        let temp = cloneDeep(recycler);
                        temp.Ban = data;
                        setRecycler(temp);
                        if (props.onUpdate !== undefined) {
                            props.onUpdate(temp);
                        }
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });

                });


           
        }

        setConfirmDialog(null);
    }

    console.log('RecyclerItem rendering ' + recycler.EmailAddress);
    let center = { // default if no location is known (Founder's Brewery, obviously)
        lat: 42.958261,
        lng: -85.6739641
    };

    function handlePhotoIDVerifiedChanged(isVerified) {
        let postData = {
            returnerId: recycler.ID,
            isVerified: isVerified
        }

        TokenService.adminServicePost(postData, 'Admin_ReturnerPhotoIdVerified')

            .then((response) => {


                if (response.Result == "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                   
                    let temp = cloneDeep(recycler);
                    temp.PhotoIdVerified = isVerified;
                    setRecycler(temp);
                    if (props.onUpdate !== undefined) {
                        props.onUpdate(temp);
                    }
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });

            });
    }

    function verifyRemovePhotoId() {
        setConfirmDialog({
            show: true,
            close: closeRemovePhotoIdDialog,
            title: 'Remove Photo Id',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>Do you want to remove this user's Photo ID?</div>,
            data: ''
        });
    }

    function closeRemovePhotoIdDialog(didAccept) {
        if (didAccept) {
            let postData = {
                returnerId: recycler.ID
            }

            TokenService.adminServicePost(postData, 'Admin_ReturnerPhotoIdRemove')

                .then((response) => {

                    if (response.Result == "SUCCESS") {
                        let temp = cloneDeep(recycler);
                       
                        temp.PhotoIdUrl = null;
                        setRecycler(temp);
                        if (props.onUpdate !== undefined) {
                            props.onUpdate(temp);
                        }
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });

                });
        }
        setConfirmDialog(null);
    }

    function handleEmailPreferenceChange(event, emailPreference) {
        let temp = cloneDeep(recycler);
        temp.EmailPreferences = emailPreference;
        setRecycler(temp);
        //updatingValue = emailPreference;
        var postData = {
            returnerId: recycler.ID,
            emailPreference: emailPreference
            
        }
        TokenService.adminServicePost(postData, 'Admin_ReturnerEmailPreferences')
            .then((response) => {

                if (response.Result == "SUCCESS") {
                    let temp = JSON.parse(response.JsonData);
                    setRecycler(temp);
                    if (props.onUpdate !== undefined) {
                        props.onUpdate(temp);
                    }
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    };

    return (<div style={{ backgroundColor: '#efefef', padding: '10px', display:'flex', maxWidth:'95vw', flexWrap:'wrap'}}>
        <Card style={{ padding: '10px', maxWidth: '300px', margin: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignSelf: 'center' }}><div>ReturnerId: {recycler.ID}</div></div>
                <div style={{ display: 'flex', alignSelf: 'center' }}><div>Phone#: {recycler.PhoneNumber}</div></div>
                <div style={{ display: 'flex', alignSelf: 'center' }}><div>Email: {recycler.EmailAddress}</div></div>
                <Avatar
                    alt="Photo"
                    src={recycler.ReturnerPhoto}
                    sx={{ width: 100, height: 100, alignSelf: 'center' }}
                />
                {recycler.PhotoIdUrl == '' ? null :
                    <div style={{ marginTop: '10px' }}>
                        <div><Fab onClick={() => verifyRemovePhotoId()} style={{ alignSelf: 'flex-end' }} size={'small'}><DeleteIcon /></Fab></div>
                        <div style={{ display: 'flex', alignSelf: 'center' }}>
                            <a href={recycler.PhotoIdUrl} target='_blank'><img src={recycler.PhotoIdUrl} style={{ maxWidth: '300px' }} /></a> 
                        </div>
                        <div style={{display:'flex',justifyContent:'flex-end'} }>
                            <div style={{alignSelf:'center'} }>Photo ID Verified:</div>
                        <Checkbox
                                checkedIcon={<CheckBoxIcon sx={{ color: 'var(--sipzee-green)', fontSize: 40 }} />}
                                icon={<CheckBoxOutlineBlankIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 40 }} />}
                                inputProps={{ 'aria-label': 'select one' }} checked={recycler.PhotoIdVerified} onChange={(e) => handlePhotoIDVerifiedChanged(e.target.checked)}
                                {...props}
                            />
                        </div>
                    </div>
            }
            </div>
        </Card>

        <Card style={{ padding: '10px', maxWidth: '300px', margin:'10px' }}>

            <TableContainer component={Paper}>
                <Table aria-label="recyler info table" className='TableRecyclerItem'>
                    <TableBody>
                        <TableRow>
                            <TableCell>Phone Verified:</TableCell>
                            <TableCell>{recycler.IsPhoneNumberVerified ? <CheckIcon sx={{ color: 'var(--sipzee-green)' }} /> : <CloseIcon sx={{ color: 'var(--sipzee-red)' }} />}</TableCell>
                        </TableRow>
                        {/*<TableRow>*/}
                        {/*    <TableCell><div>Hard Ban:</div><div style={{fontStyle:'italic'} }>No Login</div>*/}
                        {/*    </TableCell>*/}
                        {/*    <TableCell><Checkbox*/}
                        {/*        checkedIcon={<CheckBoxIcon sx={{ color: 'var(--sipzee-red)', fontSize: 40 }} />}*/}
                        {/*        icon={<CheckBoxOutlineBlankIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 40 }} />}*/}
                        {/*        inputProps={{ 'aria-label': 'select one' }} checked={!recycler.IsActive} onChange={(e) => handleHardBanUpdate(e.target.checked) }*/}
                        {/*        {...props}*/}
                        {/*    /></TableCell>*/}
                        {/*</TableRow>*/}
                        <TableRow>
                            <TableCell>
                                <div>Soft Ban:</div>
                                <div style={{ fontStyle: 'italic' }}>Can't Claim</div>
                                {recycler.Ban == null ? null :
                                    <div>{recycler.Ban.Notes}</div>
                                }
                            </TableCell>
                            <TableCell><Checkbox
                                checkedIcon={<CheckBoxIcon sx={{ color: 'var(--sipzee-red)', fontSize: 40 }} />}
                                icon={<CheckBoxOutlineBlankIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 40 }} />}
                                inputProps={{ 'aria-label': 'select one' }} checked={recycler.Ban != null} onChange={(e) => handleSoftBanChanged(e.target.checked)}
                                {...props}
                            /></TableCell>
                        </TableRow>
                        
                        <TableRow>
                            <TableCell>Email Verified:</TableCell>
                            <TableCell>{recycler.IsEmailVerified ? <CheckIcon sx={{ color: 'var(--sipzee-green)' }} /> : <CloseIcon sx={{ color: 'var(--sipzee-red)' }} />}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Training Complete:</TableCell>
                            <TableCell>{recycler.TrainingCompletedUTC != null ? <CheckIcon sx={{ color: 'var(--sipzee-green)' }} /> : <CloseIcon sx={{ color: 'var(--sipzee-red)' }} />}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>SMS Enabled:</TableCell>
                            <TableCell>{recycler.SMS_NewPickups ? <CheckIcon sx={{ color: 'var(--sipzee-green)' }} /> : <CloseIcon sx={{ color: 'var(--sipzee-red)' }} />}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2 }>
                                <ToggleButtonGroup
                                    color="primary"
                                    value={recycler.EmailPreferences}
                                    exclusive
                                    onChange={handleEmailPreferenceChange}
                                    aria-label="Email Preferences"
                                >
                                    <ToggleButton size={'small'} style={{ fontSize: '9pt', backgroundColor: (recycler.EmailPreferences === 'Daily' ? 'var(--sipzee-yellow-2)' : '') }} value="Daily">Once Daily</ToggleButton>
                                    <ToggleButton size={'small'} style={{ fontSize: '9pt', backgroundColor: (recycler.EmailPreferences === 'Immediate' ? 'var(--sipzee-yellow-2)' : '') }} value="Immediate">Immediate</ToggleButton>
                                    <ToggleButton size={'small'} style={{ fontSize: '9pt', backgroundColor: (recycler.EmailPreferences === 'None' ? 'var(--sipzee-yellow-2)' : '') }} value="None">No Emails</ToggleButton>
                                </ToggleButtonGroup>

                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
       
        </Card>

        <Card style={{ padding: '10px', maxWidth: '300px', margin: '10px' }}>

            <TableContainer component={Paper}>
                <Table aria-label="recyler info table" className='TableRecyclerItem'>
                    <TableBody>
                        {recycler.ServiceRegion === '' ? null :
                            <TableRow>
                                <TableCell>Service Region: </TableCell>
                                <TableCell>{recycler.ServiceRegion}</TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableCell>Service Area:</TableCell>
                            <TableCell>{zipcodeCounts == 0 && shapeCounts == 0 ? <CloseIcon sx={{ color: 'var(--sipzee-red)' }} /> :
                                zipcodeCounts > 0 ? <div>{'Zipcodes: ' + zipcodeCounts}</div> : null} {shapeCounts > 0 ? <div>Custom: {shapeCounts}</div> : null}
                            </TableCell>
                        </TableRow>
                        {recycler.ServiceAreas.length == 0 ? null :
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <DrawableMap
                                        width={260}
                                        center={center}
                                        // isDrawing={false}
                                        onCircleComplete={() => { }}
                                        serviceAreas={buildShapes()}
                                    />
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

        </Card>

        <Card style={{ padding: '10px', maxWidth: '300px', margin: '10px' }}>

            <TableContainer component={Paper}>
                <Table aria-label="recyler info table" className='TableRecyclerItem'>
                    <TableBody>
                       
                            <TableRow>
                                <TableCell>Abilities: </TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell>Recycle First</TableCell>
                            <TableCell>
                                <StyledCheckbox checked={recycler.Abilities.RecycleFirst}
                                    onChange={(e) => { handleAbilityUpdate(e.target.checked, 'RecycleFirst') }} />
                                
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

        </Card>
        {confirmDialog !== null ?
            <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
            : null
        }
    </div>)

} export default RecyclerItem;